module.exports = __webpack_public_path__ + "media/images/icon-notification-off@3x-cb5cb10cb643f65b0b9f2a10fb36d7e4.png";